import { Image, Typography } from 'antd';
import { Routing } from './routing';

const { Link } = Typography;

export const AppHeader: React.FC = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <Link href={Routing.main} style={{ display: 'flex', alignItems: 'center' }}>
                <Image src='/static/images/logo.svg' preview={false} height='64px' />
            </Link>
            <div style={{ flex: '1 0 0' }}></div>
            <div>
                <Image src='/static/images/maas_logo.png' preview={false} height={42} style={{ alignSelf: 'center' }} />
            </div>
        </div>
    );
};